import React from 'react';
import './Componenst.css';
import TraitorModel from '../models/TraitorModel';
import SearchModel from '../models/SearchModel';
import loading from '../../img/loading.gif';
import { decryptAes, storeKey, encryptAes } from '../../crypto-utils';
import { ip } from './../../constants';
import Swal from 'sweetalert2/src/sweetalert2'
import '@sweetalert2/themes/dark/dark.css';
import persons from '../../img/profile.png';
import { createTraitor, showError } from '../ViewCreator';

function Traitor({ changeSearch, searchModel, setView, addNew = () => {}, isAdd = false }) {

    const personModel = new TraitorModel();


    const clearSubmit = () => {
        document.getElementById('nameTraitor').value     = '';
    document.getElementById('bdateTraitor').value     = '';
    document.getElementById('adresTraitor').value     = '';
    document.getElementById('phoneTraitor').value     = '';
    document.getElementById('ipnTraitor').value     = '';
    document.getElementById('linkTraitor').value     = '';
    document.getElementById('docsTraitor').value     = '';
    document.getElementById('relTraitor').value     = '';
    
    personModel.nameTraitor = ''
    personModel.bdate = ''
    personModel.adres = ''
    personModel.phone = ''
    personModel.ipn = ''
    personModel.link = ''
    personModel.docs = ''
    personModel.rel = ''
    if (searchModel != undefined ) {
    searchModel.person.nameTraitor = ''
    searchModel.person.bdate = ''
    searchModel.person.adres = ''
    searchModel.person.phone = ''
    searchModel.person.ipn = ''
    searchModel.person.link = ''
    searchModel.person.docs = ''
    searchModel.person.rel = ''

    }
    }

    const addSubmit = () => {
      Swal.fire({
        title: 'Ви дійсно бажаєте створити новий запис',
        //text: "Оновити інформацію?",
        icon: 'question',
        html:
        '',
        showDenyButton: false,
        showCancelButton: true,
        confirmButtonText: 'Створити',
        denyButtonText: 'Оновити',

        background: '#2B2B2B',
        color: '#FFF'
      }).then((result) => {
        addNewTraitor()
        })
    }
  

      const addNewTraitor = () => {
        var path = ip + '/api/traitor/add';
        personModel.searchModel = new SearchModel()
        var bd = encryptAes(JSON.stringify(personModel))
        const requestOptions = {
          headers: {
            'Content-Type': 'Content-type: text/html'
          },
          credentials: 'include',
          uri: path,
          encoding: 'latin1',
          body: bd,
          method: 'POST'
        };
        fetch(path, requestOptions)
          .then()
          .then(response => { return response.arrayBuffer() })
          .then((buffer) => {
            const decoder = new TextDecoder('windows-1251'); // Декодуємо у CP1251
            const text = decoder.decode(buffer);
            try {
              var result = JSON.parse(text);
               showError(result.msg)
              
    
            } catch (error) {
              const decryptedText = decryptAes(text);
              var result = JSON.parse(decryptedText);
              storeKey('test_data', result.key);
              if (isAdd) {
                addNew(result.data, 20009)
                clearSubmit()
              } else {
              window.open("/edit/traitor?id="+result.data, "_self")
              }
            }
          })
      }

    const sendTraitorFullScreen = (id) => {
        window.open("/traitor?id=" + id)
    }

    const sendTraitor = (id) => {
        var path = ip + '/api/traitor/id';
       var bd = encryptAes(id)
           const requestOptions = {
             headers: {
               'Content-Type': 'Content-type: text/html; charset=win1251'
             },
             credentials: 'include',
             uri: path,
             encoding: 'latin1',
             body: bd,
             method: 'POST'
           };
           fetch(path, requestOptions)
           .then()
           .then(response => { return response.arrayBuffer() })
           .then((buffer) => {
                const decoder = new TextDecoder('windows-1251'); // Декодуємо у CP1251
                const text = decoder.decode(buffer);
                try {
                    var result = JSON.parse(text);
                    showError(result.msg)

                } catch (error) {
                    const decryptedText = decryptAes(text);
                    var result = JSON.parse(decryptedText);
                    storeKey('test_data', result.key);

                    var zz = []
                
                    var addr = result.data
                    
                    zz.push(createTraitor(addr))
    
                    String.prototype.replaceAt = function(index, replacement) {
                        return this.substr(0, index) + replacement + this.substr(index + replacement.length);
                      }
                      var spr =  document.createElement('div');
                      spr.className = "spravka"
                      
                      spr.innerHTML = "<hr><p>"+addr.infoTraitor.replace(/\r\n/g, "<p>"); 
                      zz.push(spr)

                    setView(zz)
                }
            })
    }


    const handleSubmit = (e) => {
        sendSearch();
        e.preventDefault();
    }

    const sendSearch = () => {
        var path = ip + '/api/traitor/search';
        personModel.searchModel = new SearchModel()
        var bd = encryptAes(JSON.stringify(personModel))
        const requestOptions = {
            headers: {
                'Content-Type': 'Content-type: text/html'
            },
            credentials: 'include',
            uri: path,
            encoding: 'latin1',
            body: bd,
            method: 'POST'
        };
        fetch(path, requestOptions)
            .then()
            .then(response => { return response.arrayBuffer() })
            .then((buffer) => {
                const decoder = new TextDecoder('windows-1251'); // Декодуємо у CP1251
                const text = decoder.decode(buffer);
                try {
                    var result = JSON.parse(text);
                    showError(result.msg)

                } catch (error) {
                    const decryptedText = decryptAes(text);
                    var result = JSON.parse(decryptedText);
                    storeKey('test_data', result.key);

                    var zz = []

                    for (let index = 0; index < result.data.length; index++) {
                        const tbl = document.createElement("table");
                        const tblBody = document.createElement("tbody");
                        const row = document.createElement("tr");
                        const cell1 = document.createElement("td");
                        cell1.className = "checkCell"
                        const cell2 = document.createElement("td");
    
    
    
                        var z = document.createElement('div'); // is a node
                        var pers = result.data[index]
                        var i = pers.id
                        z.className = "listItem"
                        if (pers.lastName == undefined) {
                          z.innerHTML = "<p align=\"left\">"+pers.nameTraitor+"<br>" + pers.bdate
                        } else {
                          z.innerHTML = "<p align=\"left\">"+pers.lastName + " "+ pers.firstName + " " + pers.middleName+ "<br>" + pers.bDate +"   "+pers.citizen;
                        }
                        z.style.display = "block";
                       
                          const cl = i => () =>{
                            sendTraitor(i)
                          }
                          //z.onclick = cl(pers.id)
                        
    
                       
                          
                          const dblcl = i => () =>{
                            sendTraitorFullScreen(i)
                          }
                          z.ondblclick = dblcl(pers.id)
                        
                        var per = new TraitorModel()
                        per.id = pers.id
                        tbl.value = per
                        var element = new Image();
                        if (pers.image == undefined) {
                          element.src = persons
                          element.className = 'prevImageSearchEmpty'
                        } else {
                          element.src = 'data:image/png;base64,'+pers.image
                          element.className = 'prevImageSearch'
                        }
    
                        //d.appendChild(element)
    
    
    
                        cell1.appendChild(element)
                        cell2.appendChild(z)
                        row.appendChild(cell1);
                        row.appendChild(cell2);
                        tblBody.appendChild(row);
                        tbl.appendChild(tblBody);
    
                          zz.push(tbl)
                    }
                    changeSearch(zz)
                }
            })
    }

    const handleKeyPress = (event) => {
        event = event || window.event;
        if (event.key === 'Tab') {
            closeAllHelp();
        }
        if (event.key === 'Enter') {
            closeAllHelp();
        }
        if (event.key === 'Escape') {
            closeAllHelp();
        }
    }
    const closeAllHelp = () => {
        var a = document.getElementsByClassName("list");
        for (let index = 0; index < a.length; index++) {
            a[index].innerHTML = "";
        }
    }
    const changedfield = (id) => {
        var input = document.getElementById(id)
        if (input != null) {
            if (input.value.length > 0) {
                document.getElementById(id + "List").innerHTML = "";
                sendHelp(input.value, id);
            } else {
                document.getElementById(id + "List").innerHTML = "";
            }
        }
    }

    const sendHelp = (value, id) => {
        var path = ip + '/api/help/';
        var bd = encryptAes(JSON.stringify({
            "value": value,
            "type": id
        }))
        const requestOptions = {
            headers: {
                'Content-Type': 'Content-type: text/html; charset=win1251'
            },
            credentials: 'include',
            uri: path,
            encoding: 'latin1',
            body: bd,
            method: 'POST'
        };
        fetch(path, requestOptions)
            .then()
            .then(response => { return response.arrayBuffer() })
            .then((buffer) => {
                const decoder = new TextDecoder('windows-1251'); // Декодуємо у CP1251
                const text = decoder.decode(buffer);
                try {
                    var result = JSON.parse(text);
                    showError(result.msg)

                } catch (error) {
                    const decryptedText = decryptAes(text);
                    var result = JSON.parse(decryptedText);
                    var l = result.data.list;
                    for (let index = 0; index < l.length; index++) {
                        var z = document.createElement('div'); // is a node
                        z.className = "listItem"
                        z.innerHTML = l[index];
                        z.style.display = "block";
                        z.href = "#";
                        z.onclick = () => {

                            document.getElementById(id).value = l[index]
                            document.getElementById(id + "List").innerHTML = "";

                            

                              if(id=='nameTraitor'){
                        
                                personModel.nameTraitor = l[index]
                                
                              }
                              if(id=='bdateTraitor'){
                                personModel.bdate = l[index]
                              }
                              if(id=='adresTraitor'){
                                personModel.adres = l[index]
                              }
                              if(id=='phoneTraitor'){
                                personModel.phone = l[index]
                              }
                              if(id=='ipnTraitor'){
                                personModel.ipn = l[index]
                              }
                              if(id=='docsTraitor'){
                                personModel.docs = l[index]
                              }
                              if(id=='relTraitor'){
                                personModel.rel = l[index]
                              }
                              

                        }
                        document.getElementById(id + "List").appendChild(z);

                    }
                }
            })








    }


       
    
      const namechange = () =>  {
        personModel.nameTraitor = document.getElementById('nameTraitor').value
        changedfield('nameTraitor');
      }
    
      const bdatechange = () =>  {
        personModel.bdate = document.getElementById('bdateTraitor').value
        changedfield('bdateTraitor');
      }
    
      const adreschange = () =>  {
        personModel.adres = document.getElementById('adresTraitor').value
        changedfield('adresTraitor');
      }
    
      const phonechange = () =>  {
        personModel.phone = document.getElementById('phoneTraitor').value
        changedfield('phoneTraitor');
      }
    
      const docschange = () =>  {
        personModel.docs = document.getElementById('docsTraitor').value
        changedfield('docsTraitor');
      }
    
      const linkchange = () =>  {
        personModel.link = document.getElementById('linkTraitor').value
        changedfield('linkTraitor');
      }
    
      const relchange = () =>  {
        personModel.rel = document.getElementById('relTraitor').value
        changedfield('relTraitor');
      }
    
    
    
      const ipnchange = () =>  {
        personModel.ipn = document.getElementById('ipnTraitor').value
        changedfield('ipnTraitor');
      
      }
    
      const infochange = () => {
        personModel.infoTraitor = document.getElementById('infoTraitor').value
      }


    const handleFocus = (event) => {
        closeAllHelp()
    };

    return (
        <div>
            <button id="clear-button-traitor" className="clear-button-right" onClick={clearSubmit}>Очистити
            </button>
            <button id="add-button-traitor" className="add-button-right" onClick={addSubmit}>Додати
            </button>
            <form onSubmit={handleSubmit} className="form">
                <input id="input-button-traitor" className="input-button-right" type="submit" value="Пошук" />

               

          <div id="relTraitorDrop" className="dropdown-content" onKeyDown={handleKeyPress}>
            <input  id="relTraitor" className="input-text" tabIndex="9" name="login" type="text" onChange={relchange}  placeholder="Родина" autoComplete="off" onKeyDown={handleKeyPress} onFocus={handleFocus}  />
            <div id="relTraitorList" className="list" />
          </div>

          <div id="linkTraitorDrop" className="dropdown-content" onKeyDown={handleKeyPress}>
            <input  id="linkTraitor" className="input-text" tabIndex="8" name="login" type="text" onChange={linkchange}  placeholder="Посилання" autoComplete="off" onKeyDown={handleKeyPress} onFocus={handleFocus}  />
            <div id="linkTraitorList" className="list" />
          </div>

          <div id="docsTraitorDrop" className="dropdown-content" onKeyDown={handleKeyPress}>
            <input  id="docsTraitor" className="input-text" tabIndex="7" name="login" type="text" onChange={docschange}  placeholder="Документ" autoComplete="off" onKeyDown={handleKeyPress} onFocus={handleFocus}  />
            <div id="docsTraitorList" className="list" />
          </div>

          <div id="ipnTraitorDrop" className="dropdown-content" onKeyDown={handleKeyPress}>
            <input  id="ipnTraitor" className="input-text" tabIndex="6" name="login" type="text" onChange={ipnchange}  placeholder="ІПН" autoComplete="off" onKeyDown={handleKeyPress} onFocus={handleFocus}  />
            <div id="ipnTraitorList" className="list" />
          </div>

          <div id="phoneTraitorDrop" className="dropdown-content" onKeyDown={handleKeyPress}>
            <input  id="phoneTraitor" className="input-text" tabIndex="5" name="login" type="text" onChange={phonechange}  placeholder="Телефон" autoComplete="off" onKeyDown={handleKeyPress} onFocus={handleFocus}  />
            <div id="phoneTraitorList" className="list" />
          </div>

          <div id="adresTraitorDrop" className="dropdown-content" onKeyDown={handleKeyPress}>
            <input  id="adresTraitor" className="input-text" tabIndex="3" name="login" type="text" onChange={adreschange}  placeholder="Адрес" autoComplete="off" onKeyDown={handleKeyPress} onFocus={handleFocus} />
            <div id="adresTraitorList" className="list" />
          </div>
          <div id="bdateTraitorDrop" className="dropdown-content" onKeyDown={handleKeyPress}>
            <input  id="bdateTraitor" className="input-text" tabIndex="2" name="login" type="text" onChange={bdatechange}  placeholder="Дата народження" autoComplete="off" onKeyDown={handleKeyPress} onFocus={handleFocus} />
            <div id="bdateTraitorList" className="list" />
          </div>
          <div id="nameTraitorDrop" className="dropdown-content" onKeyDown={handleKeyPress}>
            <input  id="nameTraitor" className="input-text" tabIndex="1" name="login" type="text" onChange={namechange}  placeholder="ПІБ" autoComplete="off" onKeyDown={handleKeyPress} onFocus={handleFocus}  />
            <div id="nameTraitorList" className="list" />
          </div>
            </form>
        </div>
    );
}

export default Traitor;